var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "onboardingscreen" },
    [
      _c(
        "div",
        { staticClass: "onboardingscreen__head" },
        [
          _c(
            "div",
            {
              staticClass:
                "onboardingscreen__head-title typographies-display-brand-large"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Bienvenue 🎉")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _vm.isVariationDemoButtonAtTop
            ? _c("CompassButton", {
                attrs: { label: _vm.$l10n.__("Demander une démo") },
                on: {
                  click: function($event) {
                    return _vm.redirectTo(
                      "https://go.sellsy.com/demande-de-rendez-vous",
                      "_blank"
                    )
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("OnboardingScreen", {
        attrs: { columns: _vm.columns, "is-loading": _vm.isLoading }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }